module.exports = __webpack_public_path__ + "static/img/visualbaner.f282b2a.png";


//////////////////
// WEBPACK FOOTER
// ./public/visualImg/visualbaner.png
// module id = 0JiZ
// module chunks = 0